import { atom, AtomEffect } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { Role } from 'src/types';
import { KEYS } from '../keys';
import {
  MOCK_USER_TOKEN, MOCK_USER_NAME,
  MOCK_USER_IMG, MOCK_USER_ROLE
} from '../../models/buildtime-constant';

const { persistAtom } = recoilPersist();

export type AuthState = {
  token: string;
  name: string;
  pictureBase64: string;
  role: Role;
};

const authState = atom<Partial<AuthState>>({
  key: KEYS.AUTH,
  default: {
    token: MOCK_USER_TOKEN,
    name: MOCK_USER_NAME,
    pictureBase64: MOCK_USER_IMG,
    role: MOCK_USER_ROLE as Role,
  },
  effects_UNSTABLE: [
    persistAtom,
    // persistAtom rehydrates from localStorage and overrides the atom default,
    // so a developer who has ever logged out has an empty AUTH persisted and
    // MOCK_USER_TOKEN is never consulted. Re-apply it on init when there is no
    // token. No-op in any build without the env var set (it defaults to '').
    (({ setSelf, trigger }) => {
      if (trigger !== 'get' || !MOCK_USER_TOKEN) return;
      setSelf((current) => {
        const value = current as Partial<AuthState>;
        return value?.token
          ? value
          : {
              token: MOCK_USER_TOKEN,
              name: MOCK_USER_NAME,
              pictureBase64: MOCK_USER_IMG,
              role: MOCK_USER_ROLE as Role,
            };
      });
    }) as AtomEffect<Partial<AuthState>>,
  ],
});

export default authState;
